/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import { axiosApiInstance } from '../api/axios'

import app from '../main'
import common from './modules/common'
import auth from './modules/auth'
import authenticated from './modules/authenticated'
import homepage from './modules/homepage'
import products from './modules/products'
import media from './modules/media'
import partners from './modules/partners'
import about from './modules/about'
import calculator from './modules/calculator'
import blog from './modules/blog'
import payment from './modules/payment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    aboutUsMenuPages: []
  },

  getters: {
    aboutUsMenuPages: (state) => state.aboutUsMenuPages
  },

  mutations: {
    changeLang(_state, payload) {
      app.$i18n.locale = payload
      localStorage.setItem('lang', payload)
    },

    SET_ABOUT_US_MENU_PAGES(state, payload) {
      state.aboutUsMenuPages = payload
    }
  },
  actions: {
    setLang({ commit }, payload) {
      commit('changeLang', payload)
    },

    fetchAboutUsMenuPages({ commit }) {
      axiosApiInstance
        .get('/api/public/get_menu_pages')
        .then((res) => {
          commit('SET_ABOUT_US_MENU_PAGES', res.data)
        })
        .catch((err) => console.log(err))
    }
  },
  modules: {
    common,
    auth,
    authenticated,
    homepage,
    products,
    media,
    partners,
    about,
    calculator,
    blog,
    payment
  }
})
